var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackboardChartFourth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.25 11.041667h7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 11.041667v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 11.041667v-3.333334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.333333 17.5-.833333-3.333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.666667 17.5.833333-3.333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7708333 14.1666667h-11.54166663-.00000008c-.95499167 0-1.72916667-.7741742-1.72916667-1.7291667v-8.20833333.00000026c0-.95499167.77417417-1.72916687 1.72916667-1.72916687h11.54083331.0000001c.9549917-.00046 1.7295417.77334103 1.7299999 1.72833353v.00083354 8.20749997-.000011c.0004666.9549916-.7733297 1.7295416-1.7283247 1.7300106-.0002778 0-.0005557 0-.0008335 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 11.041667v-2.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboardChartFourth);
export default __webpack_public_path__ + "static/media/blackboard-chart-fourth.cfb4ea778e97af719881d696995babe1.svg";
export { ForwardRef as ReactComponent };